<template>
    <reset-pwd-layout>
        <el-form slot="content" :rules="rules" :model="formData" ref="verifyForm">
            <div class="email-area">
                <div>Please enter your email or user ID:</div>
                <el-form-item prop="email">
                    <el-input size="small" class="email-input" v-model="formData.email"></el-input>
                    <el-button size="small" class="email-button" :class="{'disabled-button':isGetCoding}"
                               @click="getCode">{{!isGetCoding ? 'Get Code':'Sent ('+leftTime+'s)'}}
                    </el-button>
                </el-form-item>

            </div>
            <div class="info-area">
                <span v-if="!isHasSent">A verification code will be sent to your email address.</span>
                <span v-else>A verification code has been sent to your email address.</span>
            </div>
            <div class="code-area">
                <div >Please enter your verification code:</div>
                <el-form-item prop="verifyCode">
                    <el-input size="small" class="code-input" v-model="formData.verifyCode"
                              :disabled="!isHasSent"></el-input>
                </el-form-item>
            </div>
            <div class="button-area">
                <el-button size="middle" class="verify-button" :class="{'disabled-button':!formData.verifyCode}" @click="verify">Verify
                </el-button>
            </div>
        </el-form>
    </reset-pwd-layout>
</template>

<script>
    import ResetPwdLayout from "@/components/login/ResetPwdLayout";

    export default {
        name: "Verify",
        components: {ResetPwdLayout},
        data() {
            return {
                isGetCoding: false,
                isHasSent: false,
                leftTime: 60,
                formData: {
                    verifyCode: '',
                    email: '',
                },
                rules: {
                    email: [
                        {required: true, message: 'please input email', trigger: 'blur'},
                        {type: 'email', message: 'please input correct email', trigger: ['blur']}
                    ],
                    verifyCode:[
                        {required: true, message: 'please input verification code', trigger: 'blur'},
                        {len: 6, message: 'please verify code only can be 6  characters', trigger: ['blur']}
                    ]
                }
            }
        },

        methods: {
            getCode() {
                this.$refs.verifyForm.validateField('email', (error) => {
                    if (!error) {
                        this.isHasSent = true;
                        if (this.isGetCoding) return;
                        this.isGetCoding = true;
                        let clock = setInterval(() => {
                            this.leftTime--;
                            if (this.leftTime < 0) {
                                clearInterval(clock);
                                this.leftTime = 60;
                                this.isGetCoding = false;
                            }
                        }, 1000)
                    }

                })


            },
            verify(){
                this.$refs.verifyForm.validateField('verifyCode', (error) => {
                    if(!error){
                        this.$router.push({name:'resetPwd'}).catch();
                    }
                })
            }

        }

    }
</script>

<style lang="stylus" scoped>
    @import "~@/assets/stylus/color.styl"
    .email-area
        margin-top 40px
        margin-left 30px
        > div
            height 24px
            .email-input
                width: 300px
            .email-button
                margin-left 10px
                background-color $color_blue_second
                color white
                width 80px
                font-size 14px
                padding-left 5px
                padding-right 5px

    .info-area
        margin-top 30px
        height 40px
        line-height 40px
        background-color $color_gray_second
        color $color_blue_second
        padding-left 30px
        border-radius 5px

    .code-area
        margin-top 25px
        margin-left 30px
        > div
            height 24px
            .code-input
                width 180px

    .button-area
        text-align center
        margin-top 40px
        padding 0 30px
        .verify-button
            background-color $color_blue_second
            width 100%
            font-size 16px
            color white

    .disabled-button
        background-color $color_black_third !important
        cursor: not-allowed;

    >>> .el-form-item__error {
        padding-top 0;
    }

</style>
